/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { LocalDateTime } from '../../models/local-date-time';
import { LuxAverageFullResponse } from '../../models/lux-average-full-response';

export interface GetLuxAverageByFacilityAndDate$Params {
  date: LocalDateTime;
  facilityId: number;
  groupIdx?: Array<number>;
}

export function getLuxAverageByFacilityAndDate(http: HttpClient, rootUrl: string, params: GetLuxAverageByFacilityAndDate$Params, context?: HttpContext): Observable<StrictHttpResponse<LuxAverageFullResponse>> {
  const rb = new RequestBuilder(rootUrl, getLuxAverageByFacilityAndDate.PATH, 'get');
  if (params) {
    rb.query('date', params.date, {});
    rb.query('facilityId', params.facilityId, {});
    rb.query('groupIdx', params.groupIdx, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<LuxAverageFullResponse>;
    })
  );
}

getLuxAverageByFacilityAndDate.PATH = '/api/iot-events/lux-average';
